export default __webpack_public_path__ + "static/media/pipeline-image.7310f65e.d3dc7784.png";